export default "__VITE_ASSET__CZRU0HiL__"